import './list.scss';
import dataApi from '@/api/manage/poster.js';

export default {
  name: 'poster-list',
  components: {},
  data () {
    return {
      page: {
        pageSize: 10,
        pageSizes: [10, 20, 30, 40, 50, 100]
      },
      tableData: [],
      tbleOption: {
        total: 10,
        align: 'center',
        cellBtn: false,
        cancelBtn: false,
        ...this.$store.getters.tableConfig,
        column: [
          {
            label: '名称',
            prop: 'name',
            type: 'input',
            search: true,
            placeholder: '名称 ',
            addDisplay: 'true',
            editDisplay: 'true',
            required: true,
            rules: [
              {
                required: true,
                message: '名称必须填写'
              }
            ],
            span: 24
          },
          {
            label: '底图',
            prop: 'thumb',
            type: 'upload',
            limit: 1,
            span: 24,
            addDisplay: true,
            editDisplay: true,
            hide: true,
            propsHttp: {},
            dataType: 'string',
            listType: 'picture',
            accept: 'jpg/png',
            tip: '只能上传jpg/png文件，且不超过500kb',
            oss: 'ali'
          },
          {
            label: '使用场景',
            prop: 'scenario',
            type: 'select',
            addDisplay: true,
            editDisplay: true,
            dataType: 'string',
            search: 'true',
            dicUrl: `${this.$baseUrl}general/get_dict`,
            dicMethod: 'post',
            dicFlag: true,
            filterable: false,
            multiple: false,
            dicQuery: {
              dict_type: 'poster_scenario'
            },
            required: true,
            rules: [
              {
                required: true,
                message: '请选择使用场景'
              }
            ]
          },
          { // 排序
            type: 'number',
            value: 0,
            label: '排序',
            span: 12,
            display: true,
            prop: 'sorting'
          },
          {
            label: '合成规则',
            prop: 'rules',
            type: 'textarea',
            addDisplay: true,
            editDisplay: true,
            hide: true,
            span: 24,
            required: true,
            rules: [
              {
                required: true,
                message: '合成规则必须填写'
              }
            ]
          },
          {
            label: '说明 ',
            prop: 'remark',
            type: 'textarea',
            addDisplay: true,
            editDisplay: true,
            span: 24
          },
          {
            label: '状态',
            prop: 'status',
            type: 'radio',
            dataType: 'string',
            addDisplay: true,
            editDisplay: true,
            search: 'true',
            value: 1,
            dicData: [
              {
                label: '正常',
                value: 1
              },
              {
                label: '停用',
                value: 0
              }
            ]
          },
          {
            label: '合成场景',
            prop: 'is_front',
            type: 'radio',
            dataType: 'string',
            addDisplay: true,
            editDisplay: true,
            value: 1,
            dicData: [
              {
                label: '前端',
                value: 1
              }
            ]
          },
          {
            label: '创建者',
            addDisplay: false,
            editDisplay: false,
            prop: 'create_user'
          },
          {
            label: '创建时间',
            addDisplay: false,
            editDisplay: false,
            prop: 'create_time'
          },
          {
            label: '更新者',
            addDisplay: false,
            editDisplay: false,
            prop: 'update_user'
          },
          {
            label: '更新时间',
            addDisplay: false,
            editDisplay: false,
            prop: 'update_time'
          }
        ]
      },
      searchData: {}
    };
  },
  computed: {},
  filters: {},
  methods: {
    // 分页
    onLoad (page) {
      this.page = page;
      this.getList();
    },
    // 筛选
    searchChange (params, done) {
      this.searchData = params;
      this.page.currentPage = 1;
      this.getList();
      done();
    },
    // 筛选清空
    searchReset () {
      this.page.currentPage = 1;
      this.searchData = {};
      this.getList();
    },
    // 添加
    handleSubmit (form, done, loading) {
      console.log('form', form, loading);
      form.rules = JSON.stringify(form.rules);
      dataApi.add.r(form).then(res => {
        console.log(res);
        done(form);
        loading();
        this.getList();
      });
      done();
    },
    // 删除
    rowDel (form) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('删除数据', form);
        dataApi.del.r({ id: form.id }).then(res => {
          console.log(res);
          this.getList();
          this.$message.success('删除成功');
        });
      });
    },
    // 修改
    rowUpdate (form, index, done, loading) {
      console.log('index', form, index);
      dataApi.update.r(form).then(res => {
        console.log(res);
        this.getList();
        done(form);
        loading();
      });
      done();
    },
    // 获取
    getList () {
      const postData = {
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        ...this.searchData
      };
      dataApi.getList.r(postData).then(res => {
        console.log('接口返回', res);
        this.tableData = res.data.list;
        this.page.total = res.data.total;
      });
    }
  }
};
